<template>
  <el-dialog
    :title="`付款通知书${pici === '一次付款' ? '' : times == 'second' ? '(二期)' : '(一期)'}`"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="0"
    width="800px"
    :modal="false"
    class="paydoc-dia"
  >
    <div class="text-16 mgb-15">还差最后一步，千万别忘记！快写一份付款通知书发给客户吧。</div>
    <div class="mgb-15">
      <div class="text-warn text-12 mgb-10">
        您需要做三步来完成付款通知书<br />
        1、确认收款公司主体、收款批次、每次比例、哪种付款通知书模版，然后点击【下一步】开始制作<br />
        2、制作中确认收件HR及联系方式、收款金额然后点击【制作完成】自动下载为附件<br />
        3、制作完成付款通知书后，邮件发给客户HR确认，确认过后回到项目点击【开票】，该付款通知书会自动发送给财务开票
      </div>
      <div class="text-16 mgb-5">请先选择收款公司：</div>
      <div class="mgb-5">
        <el-radio-group v-model="bank">
          <el-radio label="浙江阿尔法人力资源有限公司" style="margin-bottom:5px">浙江阿尔法人力资源有限公司</el-radio>
          <el-radio label="浙江微元智能科技股份有限公司" style="margin-bottom:5px">浙江微元智能科技股份有限公司</el-radio>
          <el-radio label="北京阿尔法智人科技有限公司" style="margin-bottom:5px">北京阿尔法智人科技有限公司</el-radio>
          <el-radio label="佛山市智招科技有限公司" style="margin-bottom:5px">佛山市智招科技有限公司</el-radio>
          <el-radio label="山东阿尔法猎人科技有限公司" style="margin-bottom:5px">山东阿尔法猎人科技有限公司</el-radio>
        </el-radio-group>
      </div>
      <div>
        <span class="text-warn text-12">（请确认是以阿尔法哪家公司为收款公司，通常是签约合同公司）</span>
        <span class="rpg-btn rpg-btn-outline" style="margin-left:5px" @click="showFile">查看合同附件</span>
      </div>
    </div>
    <div class="mgb-10">
      <div class="text-16 mgb-5">开票批次：</div>
      <div class="mgb-5">
        <el-radio-group v-model="pici" @change="changePici" :disabled="times == 'second'">
          <el-radio label="一次付款">一次付款</el-radio>
          <el-radio label="二次付款">二次付款</el-radio>
        </el-radio-group>
      </div>
      <div class="text-16 mgb-5">开票比例：</div>
      <div v-if="pici == '一次付款'">100%</div>
      <div v-else>
        <div>
          <span>第一期：</span>
          <el-input size="mini" v-model="bili1" :disabled="times == 'second'" style="width:80px"></el-input>
          <span>%</span> &nbsp;&nbsp; <span>第二期：</span>
          <el-input size="mini" v-model="bili2" :disabled="times == 'second'" style="width:80px"></el-input>
          <span>%</span>
        </div>
      </div>
    </div>
    <div class="mgb-10">
      <div class="text-16 mgb-10">请点击选择付款通知书模版：</div>
      <div class="paydoc-tmps">
        <div class="paydoc-tmp" :class="{ 'paydoc-tmp-checked': tmpType == 'normal' }" @click="chooseTmp('normal')">
          <i class="el-icon-check"></i>
          <div class="mgb-5 text-12">阿尔法正常付款通知书模版</div>
          <div class="paydoc-tmp-img">
            <img v-if="pici === '一次付款'" src="../../../assets/images/pay-tmp-normal.png" /><img
              v-else-if="pici === '二次付款' && times !== 'second'"
              src="../../../assets/images/pay-tmp-normal-first.png"
            /><img
              v-else-if="pici === '二次付款' && times === 'second'"
              src="../../../assets/images/pay-tmp-normal-second.png"
            />
          </div>
          <div class="paydoc-tmp-choose" @click.stop="showBig('normal')">预览</div>
        </div>
        <div class="paydoc-tmp" :class="{ 'paydoc-tmp-checked': tmpType == 'detail' }" @click="chooseTmp('detail')">
          <i class="el-icon-check"></i>
          <div class="mgb-5 text-12">阿尔法人力/财务拆分版付款通知书模版</div>
          <div class="mgb-5 text-warn text-12">（请确认客户公司是否需要人力、财务拆开版本的付款通知书）</div>
          <div class="paydoc-tmp-img"><img src="../../../assets/images/pay-tmp-detail.png" /></div>
          <div class="paydoc-tmp-choose" @click.stop="showBig('detail')">预览</div>
        </div>
      </div>
    </div>
    <div class="mgb-10 text-right"><el-button type="primary" size="mini" @click="nextStep">下一步</el-button></div>
    <div v-if="bigtype" class="paydoc-preview">
      <i class="el-icon-close" @click="bigtype = ''"></i>
      <img v-if="bigtype == 'normal' && pici == '一次付款'" src="../../../assets/images/pay-tmp-normal.png" />
      <img
        v-if="bigtype == 'normal' && pici == '二次付款' && times !== 'second'"
        src="../../../assets/images/pay-tmp-normal-first.png"
      />
      <img
        v-if="bigtype == 'normal' && pici == '二次付款' && times == 'second'"
        src="../../../assets/images/pay-tmp-normal-second.png"
      />
      <img v-if="bigtype == 'detail'" src="../../../assets/images/pay-tmp-detail.png" />
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      bank: '浙江阿尔法人力资源有限公司',
      rid: '',
      pid: '',
      pici: '一次付款',
      bili1: '',
      bili2: '',
      times: 'first',
      tmpType: '',
      bigtype: '',
      hetong: [],
    }
  },
  methods: {
    async open({ rid, pid, times }) {
      if (!rid) return console.error('缺少rid')
      if (!pid) return console.error('缺少pid')
      this.rid = rid
      this.pid = pid
      this.tmpType = ''
      this.bigtype = ''
      this.pici = '一次付款'
      this.bili1 = ''
      this.bili2 = ''
      this.hetong = []
      if (times) this.times = times
      // 获取项目
      const project = await app.service('project').fetch(this.pid)
      if (!project) {
        return this.$message.warning('项目不存在')
      }
      this.companyName = project.客户公司
      // 合同附件预览
      const com = await app.service('company').getCompany(project.客户公司)
      if (com.status == 200) {
        if (com.result.附件 && com.result.附件.length > 0) {
          const attachs = com.result.附件
            .filter(a => a.type == '合同')
            .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
          this.hetong = attachs
          this.showFile()
        } else {
          this.$message('无合同附件')
        }
      } else {
        this.$message('未找到对应公司,无法预览合同附件')
      }
      // 获取到岗信息
      const resTowork = await app.service('radish').findTowork({ rid: this.rid, pid: this.pid })
      if (resTowork.status === 'success' && resTowork.data.length > 0) {
        const towork = resTowork.data[0]
        if (towork.开票批次) this.pici = towork.开票批次
        if (towork.第一期比例) this.bili1 = towork.第一期比例
        if (towork.第二期比例) this.bili2 = towork.第二期比例
      }
      this.dialogVisible = true
    },
    changePici(val) {
      if (val == '一次付款') {
        this.bili1 = ''
        this.bili2 = ''
        this.times = 'first'
      }
    },
    async chooseTmp(type) {
      this.tmpType = type
    },
    async nextStep() {
      if (!this.tmpType) return this.$message('请选择模板')
      const bili1 = this.bili1 ? parseInt(this.bili1) : ''
      const bili2 = this.bili2 ? parseInt(this.bili2) : ''
      if (this.pici == '二次付款') {
        if (!bili1 || !bili2) return this.$message('请填写开票比例')
        if (bili1 + bili2 != 100) return this.$message('两次开票比例相加不等于100%')
        if (this.times === 'first') {
          this.times = 'first1st' // 此处一次付款、二次付款默认times都是first，为不改变原有逻辑，此处不得已换成first1st
        }
      }
      const res = await app.service('radish').updateTowork({
        rid: this.rid,
        pid: this.pid,
        data: {
          开票批次: this.pici,
          第一期比例: bili1,
          第二期比例: bili2,
        },
        type: 'edit',
      })
      app.root.$refs.makePayDocTmpl.open({
        rid: this.rid,
        pid: this.pid,
        bank: this.bank,
        tmpType: this.tmpType,
        times: this.times,
      })
    },
    showBig(type) {
      this.bigtype = type
    },
    close() {
      this.dialogVisible = false
    },
    async showFile() {
      if (this.hetong.length == 0) {
        this.$message('无合同附件')
      } else {
        const ref = window.app.root.$refs.cvPreview
        if (ref) {
          await ref.getFile(this.hetong[0])
          ref.show()
        }
      }
    },
  },
}
</script>
<style>
.el-dialog__wrapper.paydoc-dia {
  left: auto;
}
.paydoc-dia .el-dialog {
  position: relative;
  height: 100vh;
  margin-bottom: 0;
  overflow: auto;
  border-left: 1px solid #eee;
}
.paydoc-dia .el-dialog .el-dialog__header {
  border-bottom: 1px solid #eee;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 999;
}
.paydoc-dia .el-dialog .el-dialog__body {
  color: #000;
  padding: 70px 30px 10px 30px;
  height: 100vh;
  overflow: auto;
}
.paydoc-tmps {
  display: flex;
  text-align: center;
  justify-content: space-between;
}
.paydoc-tmp {
  position: relative;
  width: 350px;
  border: 1px solid #eee;
  padding: 15px 5px 5px 5px;
  border-radius: 4px;
  cursor: pointer;
}
.paydoc-tmp .el-icon-check {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 20px;
  height: 20px;
  background: #409eff;
  color: #fff;
  font-weight: bold;
  line-height: 20px;
  border-radius: 0 0 3px 0;
}
.paydoc-tmp.paydoc-tmp-checked {
  border: 1px solid #409eff;
}
.paydoc-tmp-checked .el-icon-check {
  display: block;
}
.paydoc-tmp-choose {
  display: none;
  position: absolute;
  bottom: 5px;
  left: 5px;
  right: 5px;
  background: #ecf5ff;
  border-color: #b3d8ff;
  padding: 20px 0;
  font-weight: bold;
  color: #409eff;
}
.paydoc-tmp:hover > .paydoc-tmp-choose {
  display: block;
}
.paydoc-tmp-img {
  width: 220px;
  margin: 20px auto;
  border: 1px solid #aaa;
  min-height: 250px;
}
.paydoc-tmp-img img {
  width: 100%;
}
.paydoc-preview {
  position: absolute;
  top: 60px;
  left: 150px;
  width: 500px;
  border: 1px solid #eee;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
.paydoc-preview .el-icon-close {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
  text-align: center;
  color: #999;
  cursor: pointer;
}
.paydoc-preview img {
  width: 100%;
}
</style>
